import {AfterViewInit, Component} from '@angular/core';
import {ReserveCompleteFragmentController} from './ReserveCompleteFragmentController';
import {MatDialog} from '@angular/material/dialog';
import {BaseViewUI} from '../../../../../../BaseUI/BaseViewUI/BaseViewUI';
import {Router} from '@angular/router';
import {MstClinicDTOInterface} from '../../../../../../../DTO/MstClinicDTOInterface';
import {MstDepartmentDTOInterface} from '../../../../../../../DTO/MstDepartmentDTOInterface';
import {ReservationDetailDTOInterface} from '../../../../../../../DTO/ReservationDetailDTOInterface';
import {ReservationDTOInterface} from '../../../../../../../DTO/ReservationDTOInterface';
import {MstExaminationDTOInterface} from '../../../../../../../DTO/MstExaminationDTOInterface';
import {UserDTOInterface} from '../../../../../../../DTO/UserDTOInterface';
import {patternForName, patternForPostCode} from '../../../../../../../Util/StringUtil';
import {PrefectureConst} from '../../../../../../../Enum/PrefectureConst';
import { AppSingletonUtil } from '../../../../../../../Util/AppSingletonUtil';
import FingerprintJS from '@fingerprintjs/fingerprintjs';


@Component({
	selector: 'app-reserve-component',
	templateUrl: './ReserveCompleteFragmentComponent.html',
	styleUrls: ['../ReserveCreateFormLayout.scss', './ReserveCompleteFragmentComponent.scss'],
})
export class ReserveCompleteFragmentComponent extends BaseViewUI implements AfterViewInit {

	// 紐付いたコントローラー
	public combineCtrl: ReserveCompleteFragmentController;

	// ラインボタンのベースタイプアセットPath
	public lineBtn = 'assets/LineLoginButtonImage/images/DeskTop/1x/44dp/btn_login_base.png';

	// 予約詳細 ログインしている場合、親からセットされる
	public reservationDetail: ReservationDetailDTOInterface = {} as ReservationDetailDTOInterface;

	public reserve: ReservationDTOInterface = {} as ReservationDTOInterface;
	public clinic: MstClinicDTOInterface = {} as MstClinicDTOInterface;
	public department: MstDepartmentDTOInterface = {} as MstDepartmentDTOInterface;
	public examination: Array<MstExaminationDTOInterface> = [] as Array<MstExaminationDTOInterface>;

	public isShowCompleteMessage = true;

	// オンライン診療が可能か(電話番号、携帯の種類が登録されていればtrue)
	public isOnlineMedical = true;

	// オンライン診療の場合true
	public isOnline = false;

	// ライン連携のステータス
	public linkStatus: boolean;

	public loginUrl ='';

	public stateString = '';

	public nonceString = '';

	public userInfo: UserDTOInterface = {
		id: 0,
		lineId: '',
		lineTokenId: 0,
		lastname: '',
		middlename: '',
		firstname: '',
		lastnameKana: '',
		firstnameKana: '',
		nameRoman: 0,
		passportNo: '',
		nationalityId: '',
		gender: '',
		birthday: '',
		telNumber: '',
		deviceType: '',
		postCode: '',
		prefecture: '',
		city: '',
		address: '',
		building: '',
		toName: '',
		email: '',
		password: '',
		anonymousCode: 0,
		userNotes: '',
	};

	public prefectureList = PrefectureConst.getList();

	public errorMessageList = {
		deviceType: '',
	};


	public phoneCheckMessageList = [
		{id: 'KEEP', name: 'この携帯電話で問題ありません'},
		{id: 'UPDATE', name: '新しい携帯電話に変更します'}
	];

	public selectedPhoneCheck = 'NONE';

	/**
	 * constructor
	 */
	constructor(public dialogCtrl: MatDialog,
				public route: Router) {

		super();

		// コントローラーの生成
		this.createController(ReserveCompleteFragmentController);

	}

	/**
	 * ngAfterViewInit
	 *
	 * Angularのライフサイクル
	 * ビューの初期化後に一度だけ実行される
	 */
	public async ngAfterViewInit() {
		// 自分の初期化処理実行
		sessionStorage.removeItem('yclid');
	}

	/**
	 * 開始処理
	 */
	public async start() {
		this.log('ReserveCompleteFragmentComponent::start()');

		this.sendFingerprintLog('ReserveCompleteFragmentComponent', 'show');

		// ソーシャルPLUSとの連携状態を取得する
		const social = await this.execFuncWithErrorHandling(
			this,
			this.combineCtrl.getLineLinkStatus.bind(this),
			{ view: this }
		);
		this.linkStatus = social.result;

		this.reserve = this.reservationDetail.reservation;
		this.clinic = this.reservationDetail.mstClinic;
		this.department = this.reservationDetail.mstDepartment;
		this.examination = this.reservationDetail.mstExamination;

		// オンライン診療の場合、必要な情報が入力されているかチェック
		if (this.reserve.appointmentType === 'ONLINE') {

			// 完了前に登録情報の確認をおこなう
			this.isShowCompleteMessage = false;

			const user = await this.execFuncWithErrorHandling(
				this,
				await this.combineCtrl.getUserInfo.bind(this),
				{view: this}
			);

			console.log(user, 'YYYYY');
			this.userInfo = user;
			this.isOnlineMedical = this.checkOnlineMedical(user);
			this.isOnline = true;

			// Test
			this.isOnlineMedical = false;
		}

		const resultSendMessage = await this.execFuncWithErrorHandling(
			this,
			await this.combineCtrl.sendReserveCompleteMessage.bind(this),
			{view: this, reserveId: this.reserve.id}
		);
	}


	/**
	 * オンライン診療に必要な情報の更新
	 */
	public async onClickUpdateOnlineMedicalData() {

		console.log(this.userInfo);
		const isSave = this.checkOnlineMedicalData(this.userInfo);
		if (isSave === false) {
			return;
		}

		const ret = await this.execFuncWithErrorHandling(
			this,
			this.combineCtrl.updateOnlineMedicalData.bind(this),
			{ view: this, data: { user: this.userInfo } }
		);

		if (!ret) {
			return;
		}

		this.userInfo = ret;
		this.isOnlineMedical = this.checkOnlineMedical(this.userInfo);
	}

	/**
	 * オンライン診療の場合の登録ボタンクリック
	 */
	public async onClickRegister() {
		if (this.selectedPhoneCheck === 'KEEP') {
			this.isShowCompleteMessage = true;
		}
		if (this.selectedPhoneCheck === 'UPDATE') {
			await this.onClickUpdateOnlineMedicalData();
			this.isShowCompleteMessage = true;
		}
	}

	/**
	 * オンライン診療に必要な情報が登録されているかチェック
	 * 携帯の種類のみ必須
	 *
	 * @param user
	 * @private
	 */
	private checkOnlineMedical(user: UserDTOInterface): boolean {
		let result = true;

		result = new RegExp('^(ANDROID|IPHONE|ETC)$').test(user.deviceType);
		if (result === false) {
			return false;
		}

		return result;
	}


	/**
	 * オンライン診療に必要な情報の登録が可能か入力内容をチェック
	 * @param user
	 * @private
	 */
	private checkOnlineMedicalData(user: UserDTOInterface): boolean {
		// エラーメッセージの初期化
		this.errorMessageList = {
			deviceType: '',
		};

		let result = true;

		result = new RegExp('^(ANDROID|IPHONE|ETC)$').test(user.deviceType);
		if (result === false) {
			this.errorMessageList.deviceType = '携帯の種類を選択してください';
		}

		return result;
	}


	/**
	 * マイページHOMEへ遷移
	 */
	public async onClickHome() {

		this.sendFingerprintLog('ReserveCompleteFragmentComponent', 'onClickHome');

		await this.dismissDialogWindow();
		await this.route.navigate([''], {queryParams: {yclid: null}});
	}

	/**
	 * LINE ID連携
	 */
	public async onClickLoginLine() {

		this.sendFingerprintLog('ReserveCompleteFragmentComponent', 'onClickLoginLine');

		await this.setLoginUrl();
		if (!await this.combineCtrl.recordAuth(this.loginUrl, this.stateString, this.nonceString)) {
			this.showAlertDialog('エラー', 'ログインできません。');
		} else {
			this.showSpinnerMainView(this);
			window.location.href = this.loginUrl;
		}
	}


	/**
	 * Lineの認可リクエストURL設定
	 */
	public async setLoginUrl() {

		this.stateString = await this.combineCtrl.getState();
		this.nonceString = await this.combineCtrl.getNonce();

		const conf = await this.combineCtrl.getConfigForClient();

		await this.combineCtrl.setStateNonce({
			stateString: this.stateString,
			nonceString: this.nonceString,
		});

		this.loginUrl = conf.login_url + '?';
		this.loginUrl = this.loginUrl + `response_type=${conf.response_type}` + '&';
		this.loginUrl = this.loginUrl + `client_id=${conf.chanel_id}` + '&';
		this.loginUrl = this.loginUrl + `redirect_uri=${encodeURIComponent(conf.redirect_uri)}` + '&';
		this.loginUrl = this.loginUrl + `disable_auto_login=${conf.disable_auto_login}` + '&';
		this.loginUrl = this.loginUrl + `state=${encodeURIComponent(this.stateString)}` + '&';
		this.loginUrl = this.loginUrl + `scope=${conf.scope}` + '&';
		this.loginUrl = this.loginUrl + `nonce=${this.nonceString}` + '&';
		this.loginUrl = this.loginUrl + `bot_prompt=${conf.bot_prompt}`;
	}

	protected readonly patternForPostCode = patternForPostCode;
	protected readonly patternForName = patternForName;
}

